import axios from 'axios'
import { Message } from 'element-ui'
import storage from '@/utils/storage'
import router from '@/router'
import store from '@/store'

const api = axios.create({
  timeout: 180000,
  baseURL: '/api/zuxie/guozi'
})

// 请求拦截器
api.interceptors.request.use((config) => {
  // 取token
  const token = storage.get('token')
  if (token) {
    config.headers['YIOKS-SHIRO-TOKEN'] = token
  }
  return config
}, (err) => {
  console.error('请求发生了错误', err)
  return Promise.reject(err)
})

// 响应拦截器
const whitePath = ['/login', '/']
api.interceptors.response.use((res) => {
  const token = res.headers['yioks-shiro-token']
  const localToken = storage.get('token')
  if (token && token !== localToken && localToken) {
    storage.set('token', token)
  }
  let path = router.history.current.path
  if (res.data.code && res.data.code === 'not-logged-in') {
    storage.remove('loginToken')
    storage.remove('token')
    Message({
      message: '您的登录状态已失效，请重新登录',
      type: 'error'
    })
    if (!whitePath.includes(path)) {
      router.replace('/login')
    }
  }
  // 重复登录时的处理
  if (res.data.code === "LoginAtOtherPosition") {
    console.log("重复登录了")
    storage.remove('token')
    storage.remove('loginToken')
    storage.remove('createPlan')
    store.commit("setRepeatLogin", {
      flag: true,
      msg: '您的帐号在其他地方登录<br>如果非您本人操作<br>请及时修改密码保障帐号安全'
    });
  }
  return res.data
}, (err) => {
  Message({
    message: '系统繁忙，请稍后重试',
    type: 'error'
  })
  return Promise.reject(err)
})

export default api
